import { type CSSProperties } from 'react'
import { type ResourceModel } from '@bryntum/schedulerpro'

import { useTexts } from './useTexts'
import { useAggregateData } from './hooks/useAggregateData'

interface Props {
  record: ResourceModel
}

const containerStyle: CSSProperties = { display: 'flex', flexDirection: 'column' }
const titleStyle: CSSProperties = {
  letterSpacing: '0.0075em',
  marginBottom: '0.35rem',
  fontWeight: 500,
  fontSize: '1.25rem',
}
const textStyle: CSSProperties = {
  letterSpacing: '0.00714em',
  marginBottom: '0.35rem',
  fontWeight: 500,
  fontSize: '0.875rem',
}

export function TimeLeftTooltip(props: Props) {
  const { record } = props

  const aggregateData = useAggregateData(record)
  const texts = useTexts()

  return (
    <div style={containerStyle}>
      <div style={titleStyle}>{texts.title}</div>

      <div style={textStyle}>
        {texts.workingTime(
          aggregateData.workingTime.value,
          aggregateData.workingTime.total,
          aggregateData.workingTime.saturation,
        )}
      </div>

      <div style={textStyle}>
        {texts.drivingTime(
          aggregateData.drivingTime.value,
          aggregateData.drivingTime.total,
          aggregateData.drivingTime.saturation,
        )}
      </div>
    </div>
  )
}
